import React, { useMemo } from 'react';
import './NodeCodeComponent.css';
import NodeInfoContext from '../NodeInfoContext/NodeInfoContext';
import NodeInfoWindow from '../NodeInfoWindow/NodeInfoWindow';
import Tooltip from '../../../Tips/Tooltip/Tooltip';
import CopyButton from '../../../CopyButton/CopyButton';
import cs from 'classnames';
import ButtonLabel from '../../../Buttons/ButtonLabel/ButtonLabel';
export default function NodeCodeComponent(_ref) {
  var label = _ref.label,
    nodeData = _ref.nodeData;
  var isRestricted = useMemo(function () {
    return nodeData.restrictions !== undefined;
  }, [nodeData]);
  var isCustomized = useMemo(function () {
    return nodeData.isCustomized === true;
  }, [nodeData]);
  return /*#__PURE__*/React.createElement(NodeInfoContext.Provider, {
    value: {
      label: label,
      nodeData: nodeData
    }
  }, /*#__PURE__*/React.createElement(Tooltip, {
    Component: NodeInfoWindow,
    className: "_dm-node-popup",
    i18nKey: "".concat(nodeData.code, " Info"),
    direction: 'bottom'
  }, function (_ref2) {
    var ref = _ref2.ref,
      describedby = _ref2.describedby,
      events = _ref2.events;
    return /*#__PURE__*/React.createElement(CopyButton, Object.assign({
      className: cs('_dm-node-code', {
        '_dm-node-code--restricted': isRestricted,
        '_dm-node-code--customized': isCustomized
      }),
      ref: ref,
      "aria-describedby": describedby,
      contentToCopy: nodeData.code
    }, events), /*#__PURE__*/React.createElement(ButtonLabel, {
      i18n: {
        id: nodeData.code,
        values: {}
      }
    }));
  }));
}